import _ from 'lodash';
import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export const OpenNetworkLogBasicInfoComponent = ({
    selectOpenNetworkLogs, handleInnerFormChange, actionList, domainList, dateRangesList, handleCustomDurationChange
}: any) => {

    return (
        <>
            <AccordionContainer
                child={
                    <div className='grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        <InputContainer
                            label="Action"
                            labelField="Text"
                            list={actionList}
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'Action',
                                );
                            }}
                            optionName='Choose Action Name'
                            type="select"
                            value={selectOpenNetworkLogs?.Action}
                            valueField="Text"
                        />
                        <InputContainer
                            label="Date Range"
                            labelField="Description"
                            list={dateRangesList}
                            onValueChange={(event: any) => {
                                handleCustomDurationChange(
                                    event.target.value,
                                    'DurationUnitId',
                                );
                            }}
                            optionName='Choose Date Ranges'
                            type="select"
                            value={selectOpenNetworkLogs?.DurationUnitId}
                            valueField="Value"
                        />
                        {selectOpenNetworkLogs?.DurationUnitId === '90' &&
                            <>
                                <InputContainer
                                    isDateTimePicker={true}
                                    label="Start Date"
                                    name="StartDateIST"
                                    onValueChange={(event: any) => {
                                        handleInnerFormChange(
                                            event.target.value,
                                            'StartDateIST',
                                        );
                                    }}
                                    type="date"
                                    value={selectOpenNetworkLogs?.StartDateIST}
                                />
                                <InputContainer
                                    isDateTimePicker={true}
                                    label="End Date"
                                    name="EndDateIST"
                                    onValueChange={(event: any) => {
                                        handleInnerFormChange(
                                            event.target.value,
                                            'EndDateIST',
                                        );
                                    }}
                                    type="date"
                                    value={selectOpenNetworkLogs?.EndDateIST}
                                />
                            </>
                        }
                        <InputContainer
                            label="Transaction Id"
                            labelField="TransactionId"
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'TransactionId',
                                );
                            }}
                            type="text"
                            value={selectOpenNetworkLogs?.TransactionId}
                        />
                        <InputContainer
                            label="Message Id"
                            labelField="MessageId"
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'MessageId',
                                );
                            }}
                            type="text"
                            value={selectOpenNetworkLogs?.MessageId}
                        />
                        <InputContainer
                            label="Buyer Id"
                            labelField="BuyerId"
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'BuyerId',
                                );
                            }}
                            type="text"
                            value={selectOpenNetworkLogs?.BuyerId}
                        />
                        <InputContainer
                            label="Seller Id"
                            labelField="SellerId"
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'SellerId',
                                );
                            }}
                            type="text"
                            value={selectOpenNetworkLogs?.SellerId}
                        />
                        <InputContainer
                            label="Domain"
                            labelField="Name"
                            list={domainList}
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'DomainId',
                                );
                            }}
                            optionName='Choose Domain Name'
                            type="select"
                            value={selectOpenNetworkLogs?.DomainId}
                            valueField="Code"
                        />
                        <InputContainer
                            label="City"
                            labelField="City"
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'City',
                                );
                            }}
                            type="text"
                            value={selectOpenNetworkLogs?.City}
                        />
                    </div>
                }
                expandedPanel="Logsinfo"
                headerTitle="Search Information"
            />
        </>
    )
}

export default OpenNetworkLogBasicInfoComponent;
